import styled from '@emotion/styled';
import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { zonePlanName, type PriceZoneCode } from '../priceZone';
import { ZoneScopeText } from './ZoneScopeText';

export interface ZoneBarProps {
  zone: PriceZoneCode;
  /** 可购价区多于 1 个时才展示「更换」入口 */
  changeable: boolean;
  onChange: () => void;
}

/** 当前方案展示条：方案名 + 可授权站点范围 + 「更换」入口（fett 风格） */
const ZoneBar = (props: ZoneBarProps) => {
  const { zone, changeable, onChange } = props;
  const { t } = useTranslate();

  return (
    <Bar>
      <div>
        <ZoneName>
          <ZoneLabel>{t('当前方案')}</ZoneLabel>
          {zonePlanName(zone, t)}
        </ZoneName>
        <ZoneScope>
          {t('可授权站点')}：<ZoneScopeText zone={zone} />
        </ZoneScope>
        {/* 更换引导语（对齐 perseus subscription.purchase.zoneGuide），与更换入口同显隐 */}
        {changeable ? <ZoneGuide>{t('如需授权其他地区站点，可更换方案。')}</ZoneGuide> : null}
      </div>
      {changeable && (
        <Button onClick={onChange} disabled={!changeable}>
          {t('更换')}
        </Button>
      )}
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--fett-erp-card-bg);
  border: 1px solid var(--fett-border-default);
  border-radius: 4px;
`;
const ZoneLabel = styled.span`
  margin-right: 8px;
  font-size: 12px;
  font-weight: 400;
  color: var(--fett-text-secondary);
`;
const ZoneName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--fett-text-primary);
`;
const ZoneScope = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: var(--fett-text-secondary);
`;
const ZoneGuide = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: var(--fett-text-secondary);
`;

export default ZoneBar;
